var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M24.167 26.6667H15.8337C14.912 26.6667 14.167 27.4117 14.167 28.3333C14.167 29.255 14.912 30 15.8337 30H24.167C25.0887 30 25.8337 29.255 25.8337 28.3333C25.8337 27.4117 25.0887 26.6667 24.167 26.6667ZM24.167 16.6667H15.8337C14.912 16.6667 14.167 17.4117 14.167 18.3333C14.167 19.255 14.912 20 15.8337 20H24.167C25.0887 20 25.8337 19.255 25.8337 18.3333C25.8337 17.4117 25.0887 16.6667 24.167 16.6667ZM24.167 21.6667H15.8337C14.912 21.6667 14.167 22.4117 14.167 23.3333C14.167 24.255 14.912 25 15.8337 25H24.167C25.0887 25 25.8337 24.255 25.8337 23.3333C25.8337 22.4117 25.0887 21.6667 24.167 21.6667ZM19.167 11.6667H15.8337C14.912 11.6667 14.167 12.4117 14.167 13.3333C14.167 14.255 14.912 15 15.8337 15H19.167C20.0887 15 20.8337 14.255 20.8337 13.3333C20.8337 12.4117 20.0887 11.6667 19.167 11.6667ZM30.0003 31.6667C30.0003 32.5867 29.2537 33.3333 28.3337 33.3333H11.667C10.747 33.3333 10.0003 32.5867 10.0003 31.6667V8.33333C10.0003 7.41333 10.747 6.66667 11.667 6.66667H28.3337C29.2537 6.66667 30.0003 7.41333 30.0003 8.33333V31.6667ZM28.3337 3.33333H11.667C8.91033 3.33333 6.66699 5.57667 6.66699 8.33333V31.6667C6.66699 34.4233 8.91033 36.6667 11.667 36.6667H28.3337C31.0903 36.6667 33.3337 34.4233 33.3337 31.6667V8.33333C33.3337 5.57667 31.0903 3.33333 28.3337 3.33333Z",
          fill: _vm.color
        }
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "luminance" },
          attrs: {
            id: _vm.maskId,
            maskUnits: "userSpaceOnUse",
            x: "6",
            y: "3",
            width: "28",
            height: "34"
          }
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d:
                "M24.167 26.6667H15.8337C14.912 26.6667 14.167 27.4117 14.167 28.3333C14.167 29.255 14.912 30 15.8337 30H24.167C25.0887 30 25.8337 29.255 25.8337 28.3333C25.8337 27.4117 25.0887 26.6667 24.167 26.6667ZM24.167 16.6667H15.8337C14.912 16.6667 14.167 17.4117 14.167 18.3333C14.167 19.255 14.912 20 15.8337 20H24.167C25.0887 20 25.8337 19.255 25.8337 18.3333C25.8337 17.4117 25.0887 16.6667 24.167 16.6667ZM24.167 21.6667H15.8337C14.912 21.6667 14.167 22.4117 14.167 23.3333C14.167 24.255 14.912 25 15.8337 25H24.167C25.0887 25 25.8337 24.255 25.8337 23.3333C25.8337 22.4117 25.0887 21.6667 24.167 21.6667ZM19.167 11.6667H15.8337C14.912 11.6667 14.167 12.4117 14.167 13.3333C14.167 14.255 14.912 15 15.8337 15H19.167C20.0887 15 20.8337 14.255 20.8337 13.3333C20.8337 12.4117 20.0887 11.6667 19.167 11.6667ZM30.0003 31.6667C30.0003 32.5867 29.2537 33.3333 28.3337 33.3333H11.667C10.747 33.3333 10.0003 32.5867 10.0003 31.6667V8.33333C10.0003 7.41333 10.747 6.66667 11.667 6.66667H28.3337C29.2537 6.66667 30.0003 7.41333 30.0003 8.33333V31.6667ZM28.3337 3.33333H11.667C8.91033 3.33333 6.66699 5.57667 6.66699 8.33333V31.6667C6.66699 34.4233 8.91033 36.6667 11.667 36.6667H28.3337C31.0903 36.6667 33.3337 34.4233 33.3337 31.6667V8.33333C33.3337 5.57667 31.0903 3.33333 28.3337 3.33333Z",
              fill: "white"
            }
          })
        ]
      ),
      _c("g", { attrs: { mask: "url(#" + _vm.maskId + ")" } }, [
        _c("rect", {
          attrs: { width: _vm.size, height: _vm.size, fill: _vm.colorInternal }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }